import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-communications-dashboard',
  templateUrl: './communications-dashboard.component.html',
  styleUrls: ['./communications-dashboard.component.scss']
})
export class CommunicationsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
